import { render, staticRenderFns } from "./EstablishmentRoles.vue?vue&type=template&id=266d366a&"
import script from "./EstablishmentRoles.vue?vue&type=script&lang=js&"
export * from "./EstablishmentRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports